import { Component, HostListener, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import {
    NavigationStart,
    NavigationEnd,
    Router,
    ActivatedRoute,
} from '@angular/router';
import { Company, Camp, CompanyProvider, UserProvider, ContentProvider } from '@lighty';
import {
    EchoService,
    EmitterService,
    StorageService,
    ExternalAppsService,
    TranslateService,
    RedirectService,
    ParamsService,
} from '@services';
import { CookieService } from 'ngx-cookie-service';
import { SubscriptionCollection } from '@classes';
import { DataHelper, UrlHelper } from '@helpers';
import { environment } from '@env/environment';
import * as moment from 'moment';
import { addClass, removeClass } from '@functions';
import { CommonToastService } from '@common2/services/toast.service';
import { Subscription, Subject, switchMap, take, debounceTime, distinctUntilChanged, of, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { promises } from 'dns';
import { set } from 'date-fns';
import {
    NotificationService,
    NotificationItem,
} from 'src/app/services/notification.service';
import { PlayerService } from 'src/app/services/player.service';
import { SubscriptionLearnerService } from 'src/app/services/subscription-learner.service';
const ROLES = (company, access) => [
    {
        label: 'words.learn',
        routerLink: ['/learn', company?.slug],
        role: 'company_learner',
        hidden:
            !access.roles['companyLearner'] ||
            !access.permissions.companyAccessPlatform,
    },
    {
        label: 'words.create',
        customNavParams: {
            app: 'studio',
            routerLink: ['company', company?.slug, 'home'],
        },
        role: 'company_author',
        hidden:
            !access.roles['companyAuthor'] ||
            !access.permissions.companyAccessPlatform,
    },
    {
        label: 'words.coach',
        routerLink: ['/manage', company?.slug],
        role: 'company_manager',
        hidden:
            !access.roles['companyManager'] ||
            !access.permissions.companyAccessPlatform,
    },
    {
        label: 'words.organise',
        routerLink: ['/organize', company?.slug],
        role: 'company_administrator',
        hidden:
            !access.roles['companyAdministrator'] ||
            !access.permissions.companyAccessPlatform,
    },
];

const JOB_ROLE_MAP = {
    learn: 'company_learner',
    manage: 'company_manager',
    organize: 'company_administrator',
};

const DOCS = {
    fr: {
        learn: 'https://support.myskillcamp.com/hc/fr/categories/4859917289885-J-apprends',
        organize:
            'https://support.myskillcamp.com/hc/fr/categories/4859753911837-J-organise',
        manage: 'https://support.myskillcamp.com/hc/fr/categories/4859896516381-J-accompagne',
    },
    en: {
        learn: 'https://support.myskillcamp.com/hc/en-gb/categories/4859917289885-I-learn',
        organize:
            'https://support.myskillcamp.com/hc/en-gb/categories/4859753911837-I-organise',
        manage: 'https://support.myskillcamp.com/hc/en-gb/categories/4859896516381-I-coach',
    },
    nl: {
        learn: 'https://support.myskillcamp.com/hc/nl/categories/4859917289885-Ik-leer',
        organize:
            'https://support.myskillcamp.com/hc/nl/categories/4859753911837-Ik-organiseer',
        manage: 'https://support.myskillcamp.com/hc/nl/categories/4859896516381-Ik-begeleid',
    },
};

const SUPPORT_WEBFORMS = {
    EN: 'https://support.myskillcamp.com/hc/en-gb/requests/new',
    FR: 'https://support.myskillcamp.com/hc/fr/requests/new',
    NL: 'https://support.myskillcamp.com/hc/nl/requests/new',
};
@Component({
    selector: 'msc-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
    @ViewChild('addPinnedContentAside') addPinnedContentAside;
    @ViewChild('activeRole') activeRole;
    @Input() company: Company;
    @Input() access: any;
    /** Fuerza el estilo compacto de nav de perfil público (ancho/sticky) sin depender de detectar la ruta. */
    @Input() forcePublicProfileNav: boolean = false;
    private subscriptionCollection: SubscriptionCollection =
        new SubscriptionCollection();
    private docs = DOCS;
    public me: any;
    public currentJob: string = 'learn';

    /** Nombre corto para el header: primer nombre + primer apellido. */
    get shortName(): string {
        const first = (this.me?.firstname || '').trim().split(/\s+/)[0] || '';
        const last = (this.me?.lastname || '').trim().split(/\s+/)[0] || '';
        const short = (first + ' ' + last).trim();
        return short || (this.me?.name || '');
    }

    public displays: any;
    public campActive: Camp;
    public demoBanner: boolean = false;
    public query: string;
    public displayedQuery: string;
    public contact: any;
    public theme: any = null;
    public roles;
    public allCompanies: any[] = [];
    public availableCompanies = [];
    public companiesPickerOpen = false;
    public addPickerOpen = false;
    public profileOpen = false;
    public searchOpen = false;
    public companySearch: string = '';

    public searchButton!: HTMLElement;
    public searchContainer!: HTMLElement;
    public searchInput!: HTMLInputElement;
    public closeSearch!: HTMLElement;
    public mainMenu!: HTMLElement;

    public menuBtn!: HTMLElement;
    public mobileMenu!: HTMLElement;
    public closeMenu!: HTMLElement;
    public profileBtn!: HTMLElement;
    public mobileMenuPerfile!: HTMLElement;
    public profileMenu!: HTMLElement;
    public closeProfileMenu!: HTMLElement;
    public cursosBtn!: HTMLElement;
    public cursosMenu!: HTMLElement;
    public mobileCursosBtn!: HTMLElement;
    public mobileCursosMenu!: HTMLElement;

    public notifBtn!: HTMLElement;
    public notifPanel!: HTMLElement;
    public ulnotifPanel!: HTMLElement;
    public companiesList!: HTMLElement;

    public changeCompanyBtn!: HTMLElement;
    public changeCompanyMenu!: HTMLElement;
    public changeRoleBtn!: HTMLElement;
    public changeRoleMenu!: HTMLElement;
    public accountSettingsBtn!: HTMLElement;
    public accountSettingsMenu!: HTMLElement;
    public isProfileMenuOpen: boolean = false;
    public hasOneMentorEnabled: boolean;
    public academicProfileEnabled = false;
    private routerSubscription!: Subscription;
    public notifications: NotificationItem[] = [];
    private unreadCount: number = 0;
    private animateBell: boolean = false;
    private bellAnimationInterval: any = null;
    public showSearchBar: boolean = true;
    public showSearchContainer: boolean = false;
    //notificaciones
    public showNotificationsPanel: boolean = false;
    public gamificationEnabled = false;
    //buscador movil responsive
    public showMobileSearchInput: boolean = false;
    //perfile movil responsive menu
    public showRoleMenuMobile: boolean = false;
    public showCompanyMenuMobile: boolean = false;

    public showChangeUserRole: boolean = true;

    public showChangeUserCompany: boolean = true;

    // Predictive search
    public predictiveQuery: string = '';
    public predictiveResults: any[] = [];
    public showPredictiveDropdown: boolean = false;
    public isLoadingPredictive: boolean = false;
    private predictiveSearch$ = new Subject<string>();
    private searchCache = new Map<string, { results: any[]; ts: number }>();
    private readonly CACHE_TTL = 60000;

    // Controla si el header está en modo "scrolled" (pegado arriba sin margen).
    // El threshold es 64px (no 0) para que la transición top-4 → top-0
    // ocurra a mitad del scroll y nunca de forma brusca al llegar al tope.
    public isScrolled: boolean = false;

    // [MOBILE SCROLL SEARCH] Controla la visibilidad de la barra de búsqueda
    // predictiva en móvil. Aparece cuando el usuario hace scroll > 120px,
    // y solo se renderiza en la vista overview (ver HTML).
    public showMobileScrollSearch: boolean = false;

    public hasActiveSubscription: boolean = false;

    @HostListener('window:scroll', [])
    onWindowScroll(): void {
        this.isScrolled = window.scrollY > 64;
        // [MOBILE SCROLL SEARCH] Activa la barra de búsqueda móvil tras 120px de scroll
        this.showMobileScrollSearch = window.scrollY > 120;
    }

    constructor(
        public router: Router,
        private route: ActivatedRoute,
        private emitterService: EmitterService,
        private companyProvider: CompanyProvider,
        private userProvider: UserProvider,
        private storageService: StorageService,
        private externalAppsService: ExternalAppsService,
        private toastService: CommonToastService,
        private translateService: TranslateService,
        private redirectService: RedirectService,
        private cookieService: CookieService,
        private echoService: EchoService,
        private notificationService: NotificationService,
        private playerService: PlayerService,
        private contentProvider: ContentProvider,
        private paramsService: ParamsService,
        // [MOBILE BACK BUTTON] Location permite navegar a la sección anterior con goBack()
        private location: Location,
        private subscriptionLearnerService: SubscriptionLearnerService,
    ) {
        this.displays = {
            search: false,
            actions: false,
            help: false,
            extension: false,
            submenu: false,
            appcues: false,
            theme: false,
            compiling: false,
        };
        this.getCompanies();
    }

    get companyLogo() {
        let url = this.company.experience?.displayPicture + '?size=512' || 'https://webservices.griky.co/cdn/img/Griky-Logotipo.webp'
        if (!environment.production && url != "https://webservices.griky.co/cdn/img/Griky-Logotipo.webp") {
            url = url.replace("https://api-upgraded.myskillcamp.com.deltabluecdn.com", "https://api.myskillcamp.com");
        }
        return url;
    }

    /**
     * En el perfil público (forcePublicProfileNav) el company/access recibidos por
     * @Input pueden llegar completos DESPUÉS de ngOnInit (public-profile.component.ts
     * los refresca de forma asíncrona porque su ruta no pasa por CompanyResolver).
     * Cuando eso pasa, recalculamos academicProfileEnabled/roles con los valores ya
     * completos. No afecta al resto del header: ahí company/access no cambian tras
     * el ngOnInit inicial.
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (!this.forcePublicProfileNav) { return; }
        if (!changes['company'] && !changes['access']) { return; }
        if (!this.company || !this.access) { return; }
        this.roles = ROLES(this.company, this.access);
        this.academicProfileEnabled = !!(this.company as any)?.permissions?.academicProfileModule;
        this.countVisibleRoles(this.company, this.access);
    }

    ngOnInit(): void {
        this.me = this.storageService.get('me');
        console.log('me', this.me);
        // En el perfil público (forcePublicProfileNav) respetamos el company/access
        // recibido por @Input (sessionCompany/sessionAccess del dueño del perfil)
        // en vez de sobrescribirlo con lo que haya en StorageService.
        if (!this.forcePublicProfileNav || !this.company) {
            this.company = this.storageService.get('company');
        }
        if (!this.forcePublicProfileNav || !this.access) {
            this.access = this.storageService.get('access');
        }
        console.log('access', this.access);
        this.roles = ROLES(this.company, this.access);
        this.academicProfileEnabled = !!(this.company as any)?.permissions?.academicProfileModule;

        if (this.me) {
            this.subscriptionLearnerService.getMySubscription().subscribe({
                next: (sub) => { this.hasActiveSubscription = sub !== null; },
                error: () => { this.hasActiveSubscription = false; },
            });
        }
        this.echoService.leave(
            `channel.user.${this.me.id}.company.${this.company.id}`,
            'privateUserChannel'
        );
        this.echoService.leave(
            `channel.company.${this.company.id}`,
            'privateCompanyChannel'
        );
        this.echoService.subscribePrivateUserChannel(
            this.me.id,
            this.company.id,
            {
                'platform.private.channel.user.company': (data: any) => {
                    console.log('📥 NewNotification:', data);
                    //this.toastService.onInfo(data.message);
                    this.echoService.handleNotification(data);
                },
            }
        );
        this.echoService.subscribePrivateCompanyChannel(this.company.id, {
            'platform.private.channel.company': (data: any) => {
                console.log('📥 NewNotification:', data);
                this.echoService.handleNotification(data);
            },
        });
        this.notificationService.fetchNotifications();

        this.notificationService.getUnreadCount().subscribe((count) => {
            this.unreadCount = count;
            if (count > 0) {
                this.startBellAnimationLoop();
            }
        });

        this.notificationService.getNotifications().subscribe((nots) => {
            this.notifications = nots;
        });

        this.subscriptionCollection.subscribe = this.router.events.subscribe(
            (event) => {
                if (event instanceof NavigationStart) {
                    this.storageService.set('referrer', this.router.url);
                    this.closeAllMenusExcept();
                }

                if (event instanceof NavigationEnd) {
                    if (!this.forcePublicProfileNav) {
                        this.company = this.storageService.get('company');
                        this.access = this.storageService.get('access');
                    }
                    this.roles = ROLES(this.company, this.access);
                    this.academicProfileEnabled = !!(this.company as any)?.permissions?.academicProfileModule;
                    this.checkOneMentorAccess();
                    this.processJob();
                    this.displays.search = false;
                    this.query = null;
                    //llamado para ocultar btn search principal
                    this.updateSearchVisibility(event.urlAfterRedirects);

                    if (
                        this.externalAppsService.appcues &&
                        this.externalAppsService.appcues()
                    ) {
                        this.externalAppsService.appcues().page(); // MSC-3140
                    }
                }
            }
        );

        this.processJob();
        this.listeners();
        this.getContact();
        this.checkOneMentorAccess();
        this.countVisibleRoles(this.company, this.access);
        this.initPredictiveSearch();
    }
    ngAfterViewInit(): void {
        this.tryInitHtmlElements();
    }

    /**
     * initHtmlElements() enlaza los listeners buscando los nodos por id. Cuando el
     * header se renderiza dentro de un *ngIf que se resuelve tarde (perfil público:
     * msc-header aparece recién cuando se sabe que el visitante es el dueño), a los
     * 100 ms los nodos todavía no existen y ningún menú quedaba clickeable.
     * Reintentamos hasta que el botón de perfil exista, y enlazamos una sola vez.
     */
    private htmlElementsBound: boolean = false;
    private tryInitHtmlElements(attempt: number = 0): void {
        if (this.htmlElementsBound) { return; }

        setTimeout(() => {
            if (this.htmlElementsBound) { return; }

            if (document.getElementById('profile-btn')) {
                this.htmlElementsBound = true;
                this.initHtmlElements();
                return;
            }

            if (attempt < 40) {
                this.tryInitHtmlElements(attempt + 1);
            }
        }, 100);
    }

    ngOnDestroy(): void {
        this.echoService.leave(
            `channel.user.${this.me.id}.company.${this.company.id}`,
            'privateUserChannel'
        );
        this.echoService.leave(
            `channel.company.${this.company.id}`,
            'privateCompanyChannel'
        );
        this.emitterService.set('global.overlay', false);
        this.subscriptionCollection.unsubscribe();
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    private getContact(): void {
        this.contact = this.company.experience.contact;
    }

    displayed(type: string, force?: boolean): void {
        this.displays[type] = force || !this.displays[type];
    }

    addUser(): void {
        this.router.navigate([
            '/organize',
            this.company?.slug,
            'users',
            'action',
            'invitation',
        ]);
    }

    createCamp(): void {
        this.router.navigate(['/organize', this.company?.slug, 'camp']);
    }

    createSkill(): void {
        this.router.navigate(['/organize', this.company?.slug, 'knowledge']);
    }

    navigate(destination: string, searching?: boolean): void {
        switch (destination) {
            case 'catalogue':
            case 'contents':
            case 'communities':
                if (destination === 'communities') {
                    this.storageService.set('communitiesAvailable', true);
                }
                if (searching) {
                    this.emitterService.set(
                        'search.' + destination,
                        this.query
                    );
                }
                this.router.navigate([
                    '/learn',
                    this.company?.slug,
                    destination,
                ]);
                break;
            case 'conversation':
                this.router.navigate(['/conversation']);
                break;
        }
    }

    openSidebar(): void {
        this.emitterService.openSidebar.emit(true);
    }

    private listeners(): void {
        this.subscriptionCollection.subscribe =
            this.emitterService.campActive.subscribe((camp) => {
                this.campActive = camp;
            });

        this.subscriptionCollection.subscribe =
            this.emitterService.refreshExperience.subscribe(() => {
                const params = {
                    includes: 'experience',
                };

                this.companyProvider
                    .getCompany(this.company?.slug, params)
                    .subscribe((company) => {
                        this.company = this.storageService.get('company');
                    });
            });

        this.subscriptionCollection.subscribe =
            this.emitterService.toggleExtension.subscribe((data) => {
                if (data) {
                    if (data.type === 'template') {
                        this.storageService.set('extensionLinkData', data.data);
                    } else if (data.type === 'camp') {
                        this.storageService.set('extensionLinkCampId', data.id);
                    }
                }
                this.addPinnedContentAside.onOpen();
            });

        this.subscriptionCollection.subscribe = this.emitterService
            .get('delete.camp')
            .subscribe((data) => {
                if (data === null) {
                    this.campActive = data;
                }
            });

        this.subscriptionCollection.subscribe = this.emitterService
            .get('theme.preview.on')
            .subscribe((data) => {
                if (!DataHelper.isEmpty(data)) {
                    this.theme = data;

                    const timeOut = setTimeout(() => {
                        this.displays.theme = true;
                        if (this.theme.validate) {
                            addClass('.app-main', 'disable-overflow');
                            addClass('.overlay', 'active');
                        }
                        clearTimeout(timeOut);
                    }, 500);
                } else {
                    this.theme = null;
                    this.displays.theme = false;
                    removeClass('.app-main', 'disable-overflow');
                    removeClass('.overlay', 'active');
                }
            });

        this.subscriptionCollection.subscribe = this.emitterService
            .get('theme.compiling')
            .subscribe((data) => {
                if (!DataHelper.isEmpty(data)) {
                    this.theme = data;
                    this.displays.compiling = true;
                    addClass('.app-main', 'disable-overflow');
                    addClass('.overlay', 'active');
                } else {
                    this.displays.compiling = false;
                    removeClass('.app-main', 'disable-overflow');
                    removeClass('.overlay', 'active');
                }
            });
    }

    private getSegment(url: any, index: number = 1): string {
        return url.split('/')[index];
    }

    private processJob(): void {
        const segment = this.getSegment(this.router.url);

        switch (segment) {
            case 'learn':
            case 'organize':
            case 'manage':
                this.currentJob = this.storageService.setCache(
                    'currentJob',
                    segment,
                    null,
                    true
                );
                break;
            case 'conversation':
                // Para la ruta /conversation, mostrar header de admin (no 'learn')
                this.currentJob = 'conversation';
                break;
            default:
                this.currentJob =
                    this.storageService.getCache('currentJob') || 'learn';
        }
    }

    private isLocationActive(job: string, path: string): boolean {
        const currentLocation = this.router.url.split('/');

        return (
            currentLocation.indexOf(job) !== -1 &&
            currentLocation.indexOf(path) !== -1
        );
    }

    getTimeLastDemo(): number {
        return moment(moment(this.company.billing.expiredAt).format()).diff(
            moment(),
            'days'
        );
    }

    closeDemoBanner(): void {
        this.demoBanner = false;
        this.storageService.deleteLocal('demoMode');
        this.storageService.setLocal('demoMode', {
            show: false,
            companyName: this.company.name,
        });
    }

    search(query?): void {
        this.query = query;
        this.displays.search = false;
        const destination = this.getSegment(this.router.url, 3);

        if (destination !== 'catalogue' && destination !== 'contents') {
            this.navigate('catalogue', true);
        } else {
            this.emitterService.set('search.' + destination, this.query);
        }
    }
    get headerMaxWidthClass(): string {
        const url = this.router?.url || '';
        if (this.isPublicProfileRoute) { return 'max-w-5xl mx-auto px-6 md:px-12 w-full'; }
        return (url.includes('/catalogue') || url.includes('/contents'))
            ? 'max-w-[1320px]'
            : 'max-w-7xl';
    }

    /** Perfil público (/profile/:slug): navbar debe ajustarse al ancho de esa vista y sin el aviso de onboarding. */
    get isPublicProfileRoute(): boolean {
        return this.forcePublicProfileNav || (this.router?.url || '').includes('/profile/');
    }

    /** Navegación del menú habilitada: acceso normal a la plataforma, o en público/perfil. */
    get canNavigate(): boolean {
        return !!this.access?.permissions?.companyAccessPlatform || this.isPublicProfileRoute || !this.forcePublicProfileNav;
    }

    public openDesktopSearch(): void {
        this.showSearchContainer = true;
        this.closeAllMenusExcept();
    }

    public closeDesktopSearch(): void {
        this.showSearchContainer = false;
        this.closePredictiveDropdown();
    }

    // [MOBILE BACK BUTTON] Navega a la sección anterior del historial del navegador
    public goBack(): void {
        this.location.back();
    }

    public initPredictiveSearch(): void {
        this.predictiveSearch$
            .pipe(
                debounceTime(250),
                distinctUntilChanged((a, b) => a.trim().toLowerCase() === b.trim().toLowerCase()),
                switchMap((query) => {
                    const q = query.trim();
                    if (!q || q.length < 3) {
                        this.predictiveResults = [];
                        this.showPredictiveDropdown = q.length > 0 && q.length < 3;
                        this.isLoadingPredictive = false;
                        return of(null);
                    }
                    // Check cache first
                    const cached = this.searchCache.get(q.toLowerCase());
                    if (cached && Date.now() - cached.ts < this.CACHE_TTL) {
                        this.predictiveResults = cached.results;
                        this.showPredictiveDropdown = true;
                        this.isLoadingPredictive = false;
                        return of(null);
                    }
                    this.isLoadingPredictive = true;
                    const companyId = this.company?.id || this.storageService.get('company')?.id;
                    const params = this.paramsService.getCatalogue(null, companyId, q, null, null, this.me);
                    return forkJoin({
                        catalogue: this.contentProvider.getCatalogue(params).pipe(catchError(() => of({ catalogue: [] }))),
                        contents: this.contentProvider.getContents(params).pipe(catchError(() => of({ contents: [] }))),
                        query: of(q),
                    });
                })
            )
            .subscribe({
                next: (data: any) => {
                    if (!data) return;
                    const fromCatalogue = (data.catalogue?.catalogue || []).map((item: any) => ({ ...item, _source: 'catalogue' }));
                    const fromContents = (data.contents?.contents || []).map((item: any) => ({ ...item, _source: 'my-courses' }));
                    const combined = [...fromCatalogue, ...fromContents].slice(0, 12);
                    this.searchCache.set(data.query.toLowerCase(), { results: combined, ts: Date.now() });
                    this.predictiveResults = combined;
                    this.showPredictiveDropdown = true;
                    this.isLoadingPredictive = false;
                },
                error: (err) => {
                    console.error('[PredictiveSearch] error:', err);
                    this.isLoadingPredictive = false;
                    this.predictiveResults = [];
                    this.showPredictiveDropdown = false;
                }
            });
    }

    public onPredictiveInput(query: string): void {
        this.predictiveQuery = query ?? '';
        this.predictiveSearch$.next(query);
    }

    public onPredictiveEnter(): void {
        // Enter is intentionally blocked — user must select a result from the dropdown list
    }

    public selectPredictiveResult(item: any): void {
        this.closePredictiveDropdown();
        this.closeDesktopSearch();
        const slug = this.company?.slug;
        let url: string | null = null;

        switch (item.type) {
            case 'traject':
                url = `learn/${slug}/detail/journey/${item.data?.id}`;
                break;
            case 'external_content': {
                const providerKey = item.data?.provider?.key || item.data?.provider || 'resource';
                url = `learn/${slug}/detail/external-content/${providerKey}/${item.data?.id}`;
                break;
            }
            case 'external_video':
                url = `learn/${slug}/detail/external-content/external_video/${item.data?.id}`;
                break;
            case 'course_instance':
            case 'course_template':
                url = `learn/${slug}/detail/instance/${item.data?.id}`;
                break;
            default:
                break;
        }

        if (url) {
            this.router.navigateByUrl(url);
        } else {
            this.displayedSearch(item.data?.title || '');
        }
    }

    public getPredictivePicture(item: any): string {
        let url: string = item.data?.picture || item.picture || '';
        if (!url) return '';

        if (!environment.production) {
            url = url.replace(
                'https://api-upgraded.myskillcamp.com.deltabluecdn.com',
                'https://api.myskillcamp.com'
            );
        }

        const provider = item.data?.provider;
        const isLinkedIn =
            (typeof provider === 'string' && provider === 'linkedin-learning') ||
            (typeof provider === 'object' && provider?.key === 'linkedin');

        return isLinkedIn ? url : url + '?size=256';
    }

    public getContentTypeBadge(type: string): { label: string; classes: string } {
        const base = 'text-gray-700 bg-gray-100';
        switch (type) {
            case 'traject':
                return { label: 'api.content-type.traject', classes: base };
            case 'external_content':
                return { label: 'api.content-type.external_content', classes: base };
            case 'external_video':
                return { label: 'api.content-type.external_video', classes: base };
            case 'course_instance':
            case 'course_template':
            default:
                return { label: 'api.content-type.course', classes: base };
        }
    }

    public closePredictiveDropdown(): void {
        this.showPredictiveDropdown = false;
        this.predictiveResults = [];
        this.predictiveQuery = '';
    }

    //buscador movil responsive
    toggleMobileSearch(): void {
        this.showMobileSearchInput = !this.showMobileSearchInput;
        if (this.showMobileSearchInput) {
            setTimeout(() => {
                const el = document.getElementById('search-mobile-input') as HTMLElement;
                el?.focus();
            }, 200);
        }
    }

    closeMobileSearch(): void {
        this.showMobileSearchInput = false;
        this.predictiveQuery = '';
        this.predictiveResults = [];
        this.showPredictiveDropdown = false;
    }
    /*
        displayedSearch(query?): void {
            this.query = query;
            this.searchOpen = !!this.query;
            this.displayedQuery = this.query;
        }
    */
    //new buscador
    displayedSearch(query?): void {
        this.query = query;
        this.searchOpen = !!this.query;
        this.displayedQuery = this.query;

        const destination = this.getSegment(this.router.url, 3);

        //  Forzar navegación a catálogo si no estás ya ahí
        if (!this.router.url.includes('/catalogue')) {
            this.navigate('catalogue', true);
        } else {
            this.emitterService.set('search.catalogue', this.query);
        }
    }

    support(): void {
        if (this.currentJob === 'learn') {
            if (this.externalAppsService.isBooted('freshchat')) {
                this.externalAppsService.freshchat('open');
            } else {
                this.conversationWithManager();
            }
        } else {
            if (this.externalAppsService.isBooted('freshchat')) {
                this.externalAppsService.freshchat('open');
            }
            /* if (this.externalAppsService.isBooted('zendesk')) {
                 let url;
                 switch (this.me.language.code) {
                     case 'en':
                     case 'de':
                     case 'es':
                     case 'it':
                         url = SUPPORT_WEBFORMS.EN;
                         break;
                     case 'fr':
                         url = SUPPORT_WEBFORMS.FR;
                         break;
                     case 'nl':
                         url = SUPPORT_WEBFORMS.NL;
                         break;
                     default:
                         break;
                 }
 
                 window.open(url, '_blank');
             } */
        }
    }

    conversationWithManager(): void {
        if (this.contact && this.contact.conversationId) {
            this.router.navigate(['conversation', this.contact.conversationId]);
        } else {
            this.storageService.set('conversationUsers', [this.contact]);
            this.router.navigate(['conversation/create']);
        }
    }

    beamer(): void {
        this.externalAppsService.beamer().show();
    }

    booted(app: string): boolean {
        return this.externalAppsService.isBooted(app);
    }

    documentation(): void {
        UrlHelper.navigate(this.docs[this.me.language.code][this.currentJob]);
    }

    appointment(): void {
        const saleName: string = this.company.saleEmail
            .split('@')[0]
            .replace('.', '-');
        this.emitterService.set('global.window-embed', {
            type: 'sale',
            value: saleName,
        });
    }

    processTheme(validate?: boolean): void {
        if (validate) {
            this.emitterService.set('theme.apply', this.theme);
        } else {
            this.emitterService.set('theme.preview.off', true);
        }

        if (
            this.router.url.indexOf('experiences') === -1 ||
            this.router.url.indexOf('theme') === -1
        ) {
            this.toastService.onInfo(
                this.translateService.instant('toast.redirection.progress')
            );

            const url = `organize/${this.company?.slug}/experiences/${this.theme.experienceId}/theme`;
            this.router.navigateByUrl(url);
        }

        removeClass('.app-main', 'disable-overflow');
        removeClass('.overlay', 'active');
    }

    processRequest(): void {
        this.emitterService.set('theme.request.sale', true);
        this.processTheme();
    }

    redirect(type: string, selectedCompany): void {
        this.company = selectedCompany;
        this.cookieService.set(
            'current_company',
            selectedCompany.slug,
            10,
            '/',
            UrlHelper.getDomain(),
            false,
            'Lax'
        );
        switch (type) {
            case 'create':
                this.redirectService.navigate('studio', [
                    'company',
                    selectedCompany.slug,
                    'home',
                ]);
                break;
            case 'learn':
            case 'manage':
            case 'organize':
                this.router.navigate([type, selectedCompany.slug], {});
                break;
        }
    }

    public onSelectCompany(selectedCompany): void {
        this.companySearch = '';
        this.filterAvailableCompanies('');
        this.closePlayer();
        this.companyProvider.getCompany(selectedCompany.slug, { includes: ['roles', 'experience'] })
            .pipe(
                switchMap(company => {
                    // console.log('company', company);
                    this.storageService.set('company', company);
                    return this.companyProvider.getRoles(selectedCompany.slug);
                })
            )
            .subscribe((roles) => {
                console.log('roles', roles);
                this.storageService.set('access', roles);
                //this.company = this.storageService.get('company');
                // this.access = this.storageService.get('access');
                //this.roles = ROLES(this.company, this.access);
                //this.processJob();
                //setTimeout(() => {
                this.redirect('learn', selectedCompany);
                //}, 100);
            });

        /*
        if (selectedCompany.availableRoles.indexOf(JOB_ROLE_MAP[this.currentJob]) === -1) {
            this.redirect('learn', selectedCompany);
            this.company = this.storageService.get('company');
            this.access = this.storageService.get('access');
            this.roles = ROLES(this.company, this.access);
            this.processJob();
        } else {
            this.redirect(this.currentJob, selectedCompany);
        }
  */
    }

    public getCompanySubtitle(count = 0): string {
        const formatter = Intl.NumberFormat('en', { notation: 'compact' });
        const translation =
            count === 1
                ? this.translateService.instant('words.member')
                : this.translateService.instant('words.members');

        return `${formatter.format(count)} ${translation.toLowerCase()}`;
    }

    public getCompanies() {
        return this.userProvider
            .getCompanies({ includes: 'roles,experience' })
            .subscribe((data) => {
                this.availableCompanies = data.map((company) => ({
                    logo: company.experience?.displayPicture,
                    title: company.experience?.displayName || company.name,
                    subtitle: this.getCompanySubtitle(company.usersCount),
                    availableRoles: company.roles,
                    ...company,
                }));
                this.allCompanies = this.availableCompanies;
                this.countVisibleCompanies();
            });
    }

    public navigateTo(navParams: any): void {
        this.redirectService.navigate(navParams.app, navParams.routerLink);
        this.closePlayer();
    }

    public logout(): void {
        this.emitterService.set('global.logout', true);
    }

    // Función para verificar si es móvil
    public isMobile(): boolean {
        return window.innerWidth <= 768;
    }

    // Función para cerrar menús al hacer clic en enlaces
    public closeMenuOnClick(menu: HTMLElement): void {
        if (menu) {
            const links = menu.querySelectorAll('a');
            links.forEach((link) => {
                link.addEventListener('click', () => {
                    menu.classList.add('hidden');
                });
            });
        }
    }

    public closeAllMenusExcept(exceptions: HTMLElement[] = []): void {
        const menusToClose = [
            this.cursosMenu,
            this.mobileCursosMenu,
            this.profileMenu,
            this.mobileMenuPerfile,
            this.notifPanel,
            this.changeCompanyMenu,
            this.changeRoleMenu,
            this.accountSettingsMenu,
            this.mobileMenu,
        ];

        if (this.isMobile() && this.mainMenu) {
            menusToClose.push(this.mainMenu);
        }

        menusToClose.forEach((menu) => {
            if (
                menu &&
                !exceptions.includes(menu) &&
                !menu.classList.contains('hidden')
            ) {
                this.closeDropdown(menu);
            }
        });

        // Actualizar flag del menú de perfil
        if (
            (this.profileMenu && !exceptions.includes(this.profileMenu)) ||
            (this.mobileMenuPerfile &&
                !exceptions.includes(this.mobileMenuPerfile))
        ) {
            this.isProfileMenuOpen = false;
        }
    }

    /**
     * Handler de Angular para el botón de perfil. Existe porque initHtmlElements()
     * enlaza por getElementById y, cuando el header se renderiza dentro de un *ngIf
     * que se resuelve tarde (perfil público), ese enlace puede quedar apuntando a un
     * nodo que ya fue reemplazado y el menú no abría hasta recargar la vista.
     * Si el nodo ya tiene listener imperativo, no hace nada para no togglear dos veces.
     */
    public toggleProfileMenu(event: Event): void {
        const target = event.currentTarget as HTMLElement;
        if (target?.dataset?.boundProfileMenu === '1') { return; }
        event.stopPropagation();
        this.performProfileMenuToggle();
    }

    /** Abre/cierra el menú de perfil resolviendo los nodos en el momento del click. */
    private performProfileMenuToggle(): void {
        this.mainMenu = this.mainMenu || (document.getElementById('main-nav') as HTMLElement);
        this.profileMenu = document.getElementById('profile-menu') as HTMLElement;
        this.mobileMenuPerfile = document.getElementById('mobile-menu-perfile') as HTMLElement;

        if (this.isMobile()) {
            if (!this.mobileMenuPerfile) { return; }

            if (this.mobileMenuPerfile.classList.contains('hidden')) {
                this.closeAllMenusExcept([this.mobileMenuPerfile]);
                this.openDropdown(this.mobileMenuPerfile);
            } else {
                this.closeDropdown(this.mobileMenuPerfile);
            }
            this.isProfileMenuOpen = !this.mobileMenuPerfile.classList.contains('hidden');
            if (this.mainMenu) {
                this.mainMenu.classList.add('hidden');
            }
            return;
        }

        if (!this.profileMenu) { return; }

        if (this.profileMenu.classList.contains('hidden')) {
            this.closeAllMenusExcept([this.profileMenu]);
            this.openDropdown(this.profileMenu);
            this.isProfileMenuOpen = true;
        } else {
            this.closeDropdown(this.profileMenu);
            this.isProfileMenuOpen = false;
        }
    }

    public openDropdown(menu: HTMLElement): void {
        menu.classList.remove('hidden', 'animate-dropdown-exit');
        menu.classList.add('animate-dropdown-enter');
    }

    public closeDropdown(menu: HTMLElement): void {
        menu.classList.remove('animate-dropdown-enter');
        menu.classList.add('animate-dropdown-exit');
        setTimeout(() => {
            menu.classList.add('hidden');
            menu.classList.remove('animate-dropdown-exit');
        }, 300);
    }

    public filterAvailableCompanies(searchTerm: string): void {
        if (!searchTerm.trim()) {
            this.availableCompanies = [...this.allCompanies];
        } else {
            this.availableCompanies = this.allCompanies.filter((company) =>
                company.title.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
    }

    public initHtmlElements(): void {
        // Notificaciones móvil
        const notifMobileBtn = document.getElementById('notif-mobile-btn') as HTMLElement;
        const notifMobilePanel = document.getElementById('notif-mobile-panel') as HTMLElement;
        const closeNotifMobile = document.getElementById('close-notif-mobile') as HTMLElement;

        this.searchButton = document.querySelector('.fa-search') as HTMLElement;
        this.searchContainer = document.getElementById(
            'search-container'
        ) as HTMLElement;
        this.searchInput = document.getElementById(
            'search-input'
        ) as HTMLInputElement;
        this.closeSearch = document.getElementById(
            'close-search'
        ) as HTMLElement;
        this.mainMenu = document.getElementById('main-nav') as HTMLElement;
        this.menuBtn = document.getElementById('menu-btn') as HTMLElement;
        this.mobileMenu = document.getElementById('mobile-menu') as HTMLElement;
        this.closeMenu = document.getElementById('close-menu') as HTMLElement;
        this.profileBtn = document.getElementById('profile-btn') as HTMLElement;
        this.mobileMenuPerfile = document.getElementById(
            'mobile-menu-perfile'
        ) as HTMLElement;
        this.profileMenu = document.getElementById(
            'profile-menu'
        ) as HTMLElement;
        this.closeProfileMenu = document.getElementById(
            'close-profile-menu'
        ) as HTMLElement;
        this.cursosBtn = document.getElementById('cursos-btn') as HTMLElement;
        this.cursosMenu = document.getElementById('cursos-menu') as HTMLElement;
        this.mobileCursosBtn = document.getElementById(
            'mobile-cursos-btn'
        ) as HTMLElement;
        this.mobileCursosMenu = document.getElementById(
            'mobile-cursos-menu'
        ) as HTMLElement;
        this.notifBtn = document.getElementById('notifBtn') as HTMLElement;
        this.notifPanel = document.getElementById('notifPanel') as HTMLElement;
        this.ulnotifPanel = document.getElementById(
            'ulnotifPanel'
        ) as HTMLElement;
        this.companiesList = document.getElementById(
            'companiesList'
        ) as HTMLElement;
        this.changeCompanyBtn = document.getElementById(
            'change-company-btn'
        ) as HTMLElement;
        this.changeCompanyMenu = document.getElementById(
            'change-company-menu'
        ) as HTMLElement;
        this.changeRoleBtn = document.getElementById(
            'change-role-btn'
        ) as HTMLElement;
        this.changeRoleMenu = document.getElementById(
            'change-role-menu'
        ) as HTMLElement;
        this.changeCompanyMenu = document.getElementById(
            'change-company-menu'
        ) as HTMLElement;
        this.changeRoleBtn = document.getElementById(
            'change-role-btn'
        ) as HTMLElement;
        this.changeRoleMenu = document.getElementById(
            'change-role-menu'
        ) as HTMLElement;
        this.accountSettingsBtn = document.getElementById(
            'account-settings-btn'
        ) as HTMLElement;
        this.accountSettingsMenu = document.getElementById(
            'account-settings-menu'
        ) as HTMLElement;

        // ----- Buscador -----
        if (
            this.searchButton &&
            this.searchContainer &&
            this.searchInput &&
            this.closeSearch &&
            this.mainMenu
        ) {
            this.searchButton.addEventListener('click', () => {
                this.searchContainer.classList.remove('hidden');
                this.mainMenu.classList.add('hidden', 'opacity-0', 'invisible');
                this.searchButton.classList.add('hidden');
                this.closeAllMenusExcept();

                setTimeout(() => {
                    this.searchContainer.classList.remove(
                        'opacity-0',
                        'scale-95'
                    );
                    this.searchInput.classList.remove('opacity-0', 'scale-95');
                }, 10);

                this.searchInput.focus();
            });

            this.closeSearch.addEventListener('click', () => {
                this.searchContainer.classList.add('opacity-0', 'scale-95');
                this.searchInput.classList.add('opacity-0', 'scale-95');

                setTimeout(() => {
                    this.searchContainer.classList.add('hidden');
                    this.searchButton.classList.remove('hidden');

                    if (!this.isMobile()) {
                        this.mainMenu.classList.remove(
                            'hidden',
                            'opacity-0',
                            'invisible'
                        );
                    } else {
                        this.mainMenu.classList.add('hidden');
                    }
                }, 300);
            });

            this.searchInput.addEventListener(
                'keydown',
                (event: KeyboardEvent) => {
                    if (event.key === 'Escape') {
                        this.searchContainer.classList.add(
                            'opacity-0',
                            'scale-95'
                        );
                        this.searchInput.classList.add('opacity-0', 'scale-95');

                        setTimeout(() => {
                            this.searchContainer.classList.add('hidden');
                            this.searchButton.classList.remove('hidden');

                            if (!this.isMobile()) {
                                this.mainMenu.classList.remove(
                                    'hidden',
                                    'opacity-0',
                                    'invisible'
                                );
                            } else {
                                this.mainMenu.classList.add('hidden');
                            }
                        }, 300);
                    }
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        // TODO: aquí ejecutar tu búsqueda si no está en otro método

                        this.searchInput.value = '';
                        // Tiempo de cierre
                        this.closeSearch.click();
                    }
                }
            );

            document.addEventListener('click', (evt: Event) => {
                const target = evt.target as Node;
                const clickedInside =
                    this.searchContainer.contains(target) ||
                    this.searchButton.contains(target) ||
                    this.closeSearch.contains(target);

                if (
                    !clickedInside &&
                    !this.searchContainer.classList.contains('hidden')
                ) {
                    // primero cierras visualmente
                    this.closeSearch.click();
                    // luego reseteas el input
                    this.searchInput.value = '';
                }
                const keyboardEvent = event as KeyboardEvent;
                if (keyboardEvent.key === "Enter") {
                    keyboardEvent.preventDefault();
                    // TODO: aquí ejecutar tu búsqueda si no está en otro método

                    this.searchInput.value = '';
                    // Tiempo de cierre
                    this.closeSearch.click();
                }
            });

            document.addEventListener("click", (evt: Event) => {
                const target = evt.target as Node;
                const clickedInside =
                    this.searchContainer.contains(target) ||
                    this.searchButton.contains(target) ||
                    this.closeSearch.contains(target);

                if (!clickedInside && !this.searchContainer.classList.contains("hidden")) {
                    // primero cierras visualmente
                    this.closeSearch.click();
                    // luego reseteas el input
                    this.searchInput.value = '';
                }
            });
        }
        // ----- notificaciones movil responsive -----
        if (notifMobileBtn && notifMobilePanel) {
            notifMobileBtn.addEventListener('click', () => {
                if (notifMobilePanel.classList.contains('hidden')) {
                    this.closeAllMenusExcept([notifMobilePanel]);
                    this.openDropdown(notifMobilePanel);
                    this.stopBellAnimationLoop();
                    this.showNotificationsPanel = true; // 🔥 ACTIVA PANEL RESPONSIVE
                } else {
                    this.closeDropdown(notifMobilePanel);
                    this.showNotificationsPanel = false; // opcional si quieres que se oculte al cerrar
                }
            });

        }

        if (closeNotifMobile && notifMobilePanel) {
            closeNotifMobile.addEventListener('click', () => {
                this.closeDropdown(notifMobilePanel);
            });
        }


        // ----- Menús de cambio de rol y empresa -----
        this.changeCompanyBtn?.addEventListener('click', (event) => {
            event.stopPropagation();
            if (this.changeCompanyMenu.classList.contains('hidden')) {
                this.closeDropdown(this.changeRoleMenu);
                this.closeAllMenusExcept([
                    this.changeCompanyMenu,
                    this.profileMenu,
                    this.mobileMenuPerfile,
                ]);
                this.openDropdown(this.changeCompanyMenu);
            } else {
                this.closeDropdown(this.changeCompanyMenu);
            }
        });

        this.changeRoleBtn?.addEventListener('click', (event) => {
            event.stopPropagation();
            if (this.changeRoleMenu.classList.contains('hidden')) {
                this.closeDropdown(this.changeCompanyMenu);
                this.closeDropdown(this.accountSettingsMenu);
                this.closeAllMenusExcept([
                    this.changeRoleMenu,
                    this.profileMenu,
                    this.mobileMenuPerfile,
                ]);
                this.openDropdown(this.changeRoleMenu);
            } else {
                this.closeDropdown(this.changeRoleMenu);
            }
        });

        // Configuración: submenú Mi perfil / Mi configuración / Mi suscripción
        this.accountSettingsBtn?.addEventListener('click', (event) => {
            event.stopPropagation();
            if (this.accountSettingsMenu.classList.contains('hidden')) {
                this.closeDropdown(this.changeCompanyMenu);
                this.closeDropdown(this.changeRoleMenu);
                this.closeAllMenusExcept([
                    this.accountSettingsMenu,
                    this.profileMenu,
                    this.mobileMenuPerfile,
                ]);
                this.openDropdown(this.accountSettingsMenu);
            } else {
                this.closeDropdown(this.accountSettingsMenu);
            }
        });

        // Control de hover
        this.changeCompanyBtn?.addEventListener('mouseenter', (e) => {
            e.stopPropagation();
            if (!this.changeRoleMenu.classList.contains('hidden')) {
                this.closeDropdown(this.changeCompanyMenu);
            }
            if (!this.accountSettingsMenu.classList.contains('hidden')) {
                this.closeDropdown(this.accountSettingsMenu);
            }
        });

        this.changeRoleBtn.addEventListener('mouseenter', (e) => {
            e.stopPropagation();
            if (!this.changeCompanyMenu.classList.contains('hidden')) {
                this.closeDropdown(this.changeRoleMenu);
            }
            if (!this.accountSettingsMenu.classList.contains('hidden')) {
                this.closeDropdown(this.accountSettingsMenu);
            }
        });

        this.accountSettingsBtn?.addEventListener('mouseenter', (e) => {
            e.stopPropagation();
            if (!this.changeCompanyMenu.classList.contains('hidden')) {
                this.closeDropdown(this.changeCompanyMenu);
            }
            if (!this.changeRoleMenu.classList.contains('hidden')) {
                this.closeDropdown(this.changeRoleMenu);
            }
        });

        // Cierre al hacer clic fuera
        const closeRoleCompanyMenus = (e: Event) => {
            if (
                this.changeCompanyMenu &&
                !this.changeCompanyBtn.contains(e.target as Node)
            ) {
                this.closeDropdown(this.changeCompanyMenu);
            }
            if (
                this.changeRoleMenu &&
                !this.changeRoleBtn.contains(e.target as Node)
            ) {
                this.closeDropdown(this.changeRoleMenu);
            }
            if (
                this.accountSettingsMenu &&
                this.accountSettingsBtn &&
                !this.accountSettingsBtn.contains(e.target as Node)
            ) {
                this.closeDropdown(this.accountSettingsMenu);
            }
        };

        document.addEventListener('click', (e) => {
            closeRoleCompanyMenus(e);
        });

        // ----- Menú principal Mobile (sin cambios) -----
        if (this.menuBtn && this.mobileMenu) {
            this.menuBtn.addEventListener('click', () => {
                if (this.isMobile()) {
                    if (this.mobileMenu.classList.contains('hidden')) {
                        this.closeAllMenusExcept([this.mobileMenu]);
                        this.openDropdown(this.mobileMenu);
                    } else {
                        this.closeDropdown(this.mobileMenu);
                    }
                    if (this.mainMenu) {
                        this.mainMenu.classList.add('hidden');
                    }
                }
            });
        }
        if (this.closeMenu) {
            this.closeMenu.addEventListener('click', () => {
                this.closeDropdown(this.mobileMenu);
            });
        }

        // ----- Menú de perfil -----
        if (this.profileBtn) {
            // Marca el nodo como ya enlazado para que el handler de Angular
            // (toggleProfileMenu) no dispare un segundo toggle sobre el mismo click.
            this.profileBtn.dataset.boundProfileMenu = '1';
            this.profileBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.performProfileMenuToggle();
            });
        }
        if (this.closeProfileMenu) {
            this.closeProfileMenu.addEventListener('click', () => {
                if (this.isMobile()) {
                    if (this.mobileMenuPerfile) {
                        this.closeDropdown(this.mobileMenuPerfile);
                        this.isProfileMenuOpen = false;
                    }
                } else {
                    if (this.profileMenu) {
                        this.closeDropdown(this.profileMenu);
                        this.isProfileMenuOpen = false;
                    }
                }
            });
        }

        // ----- Menú de cursos -----
        if (this.cursosBtn && this.cursosMenu) {
            const cursosToggle = this.cursosBtn.querySelector(
                '.fa-chevron-down'
            ) as HTMLElement;
            if (cursosToggle) {
                cursosToggle.addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (!this.isMobile()) {
                        if (this.cursosMenu.classList.contains('hidden')) {
                            this.closeAllMenusExcept([this.cursosMenu]);
                            this.openDropdown(this.cursosMenu);
                        } else {
                            this.closeDropdown(this.cursosMenu);
                        }
                    }
                });
            }
        }
        if (this.mobileCursosBtn && this.mobileCursosMenu) {
            this.mobileCursosBtn.addEventListener('click', () => {
                if (this.isMobile()) {
                    if (this.mobileCursosMenu.classList.contains('hidden')) {
                        this.closeAllMenusExcept([this.mobileCursosMenu]);
                        this.openDropdown(this.mobileCursosMenu);
                    } else {
                        this.closeDropdown(this.mobileCursosMenu);
                    }
                    if (this.mainMenu) {
                        this.mainMenu.classList.add('hidden');
                    }
                }
            });
        }

        // Cerrar menús al hacer clic en un enlace
        this.closeMenuOnClick(this.mobileMenu);
        this.closeMenuOnClick(this.mobileMenuPerfile);

        // ----- Notificaciones (sin cambios) -----
        if (this.notifBtn && this.notifPanel) {
            this.notifBtn.addEventListener('click', () => {
                if (this.notifPanel.classList.contains('hidden')) {
                    this.closeAllMenusExcept([this.notifPanel]);
                    this.openDropdown(this.notifPanel);
                    this.stopBellAnimationLoop();
                } else {
                    this.closeDropdown(this.notifPanel);
                }
                if (this.isMobile() && this.mainMenu) {
                    this.mainMenu.classList.add('hidden');
                }
            });
        }
        if (this.ulnotifPanel) {
            this.ulnotifPanel.addEventListener(
                'wheel',
                (e: WheelEvent) => {
                    const el = this.ulnotifPanel;
                    const scrollTop = el.scrollTop;
                    const scrollHeight = el.scrollHeight;
                    const clientHeight = el.clientHeight;
                    const delta = e.deltaY;

                    const isScrollingUp = delta < 0;
                    const isScrollingDown = delta > 0;

                    const isAtTop = scrollTop === 0;
                    const isAtBottom = scrollTop + clientHeight >= scrollHeight;

                    if (
                        (isAtTop && isScrollingUp) ||
                        (isAtBottom && isScrollingDown)
                    ) {
                        e.preventDefault(); // previene scroll en el body
                    }
                    // Si no está en tope o fondo, no se hace preventDefault y scrolla normal
                },
                { passive: false }
            );
        }
        if (this.companiesList) {
            this.companiesList.addEventListener(
                'wheel',
                (e: WheelEvent) => {
                    const el = this.companiesList;
                    const scrollTop = el.scrollTop;
                    const scrollHeight = el.scrollHeight;
                    const clientHeight = el.clientHeight;
                    const delta = e.deltaY;

                    const isScrollingUp = delta < 0;
                    const isScrollingDown = delta > 0;

                    const isAtTop = scrollTop === 0;
                    const isAtBottom = scrollTop + clientHeight >= scrollHeight;

                    if (
                        (isAtTop && isScrollingUp) ||
                        (isAtBottom && isScrollingDown)
                    ) {
                        e.preventDefault(); // previene scroll en el body
                    }
                    // Si no está en tope o fondo, no se hace preventDefault y scrolla normal
                },
                { passive: false }
            );
        }

        document.addEventListener('click', (event) => {
            if (
                this.notifBtn &&
                this.notifPanel &&
                !this.notifBtn.contains(event.target as Node) &&
                !this.notifPanel.contains(event.target as Node)
            ) {
                this.closeDropdown(this.notifPanel);
            }
        });

        // ----- Listeners globales para cerrar menús al hacer scroll o clic fuera -----
        window.addEventListener('scroll', () => {
            this.closeAllMenusExcept();
        });

        document.addEventListener('click', (e) => {
            // Si el menú de perfil está abierto y el clic ocurre sobre alguno de sus submenús
            // (cambiar de empresa/rol) no se cierra el menú padre.
            if (
                this.profileMenu &&
                !this.profileMenu.classList.contains('hidden') &&
                (this.changeCompanyBtn.contains(e.target as Node) ||
                    this.changeRoleBtn.contains(e.target as Node) ||
                    this.changeCompanyMenu.contains(e.target as Node) ||
                    this.changeRoleMenu.contains(e.target as Node) ||
                    (this.accountSettingsBtn && this.accountSettingsBtn.contains(e.target as Node)) ||
                    (this.accountSettingsMenu && this.accountSettingsMenu.contains(e.target as Node)))
            ) {
                return;
            }

            const allowedElements = [
                this.profileMenu,
                this.mobileMenuPerfile,
                this.cursosMenu,
                this.mobileCursosMenu,
                this.notifPanel,
                this.changeCompanyMenu,
                this.changeRoleMenu,
                this.accountSettingsMenu,
                this.mobileMenu,
                this.mainMenu,
                this.searchContainer,
            ];
            const allowedToggles = [
                this.profileBtn,
                this.cursosBtn,
                this.notifBtn,
                this.changeCompanyBtn,
                this.changeRoleBtn,
                this.accountSettingsBtn,
                this.menuBtn,
                this.mobileCursosBtn,
                this.searchButton,
                this.closeSearch,
            ];

            let clickedInside = false;
            allowedElements.forEach((el) => {
                if (el && el.contains(e.target as Node)) {
                    clickedInside = true;
                }
            });
            allowedToggles.forEach((el) => {
                if (el && el.contains(e.target as Node)) {
                    clickedInside = true;
                }
            });

            if (!clickedInside) {
                this.closeAllMenusExcept();
            }
        });
    }
    //btn ocultar search principal
    private updateSearchVisibility(url: string): void {
        const normalizedUrl = url.toLowerCase();

        this.showSearchBar = !(
            normalizedUrl.includes('/catalogue') ||
            normalizedUrl.includes('/contents') ||
            normalizedUrl.includes('/my-courses') ||
            normalizedUrl.includes('/catalogue/all') ||
            normalizedUrl.includes('/contents/all')
        );
    }



    public checkOneMentorAccess(): void {
        if (this.company.permissions.companyProviderOnementor) {
            const params = {
                company_id: this.company.id
            }
            this.companyProvider.GetServicesOnDemand(params).pipe(take(1)).subscribe((onDemand) => {
                console.log(onDemand)
                if (onDemand.serviceProviders.length != 0) {
                    this.companyProvider.CompanyUserMe(this.company.id).pipe(take(1)).subscribe((me) => {
                        console.log(me)
                        const paramsMe = {
                            company_id: this.company.id,
                            company_user_id: me.companyUser
                        }
                        this.companyProvider.GetServiceForLearnerOnDemandService(paramsMe).pipe(take(1)).subscribe((access) => {
                            console.log(access)
                            this.hasOneMentorEnabled = access[0].haveAccess;
                            this.processJob();
                        });
                    })
                } else {
                    this.hasOneMentorEnabled = true;
                    this.processJob();
                }
            })
        } else {
            this.hasOneMentorEnabled = false;
            this.processJob();
        }
    }
    public startBellAnimationLoop(): void {
        if (this.bellAnimationInterval) return; // ya está corriendo

        this.bellAnimationInterval = setInterval(() => {
            if (this.unreadCount === 0) return;

            this.animateBell = true;
            setTimeout(() => (this.animateBell = false), 600); // dura 600ms
        }, 2000); // cada 2 segundos
    }
    public stopBellAnimationLoop(): void {
        if (this.bellAnimationInterval) {
            clearInterval(this.bellAnimationInterval);
            this.bellAnimationInterval = null;
            this.animateBell = false;
        }
    }
    public markAsRead(id: number): void {
        this.notificationService.markAsRead(id);
    }
    public markAllAsRead(): void {
        this.notificationService.markAllAsRead();
    }

    private shouldHideContent(url: string): boolean {
        return url.includes('catalogue') || url.includes('contents');
    }

    public closeSearchBar(): void {
        this.showSearchContainer = false;
        this.showMobileSearchInput = false;
    }

    public closePlayer(): void {
        this.playerService.closeIframe();
    }

    public countVisibleRoles(company: any, access: any): void {
        if(ROLES(company, access).filter(r => !r.hidden).length === 1) {
            this.showChangeUserRole = false;
        }
    }

    public countVisibleCompanies(): void {
        console.log('Available companies',this.allCompanies.length);
        if(this.allCompanies.length < 2) {
            this.showChangeUserCompany = false;
        }
    }
}
